// test2871
(2871 && 0);
